import { DocumentService } from "./DocumentService";
import { UserService } from "./UserService";

export class Services {
  static User = new UserService();
  static Document = new DocumentService();
}
